module.exports = __webpack_public_path__ + "img/infograph.961a2c73.svg";